function SchemaMeta({ prop, content }: { prop: string; content: string }) {
  return (
    <meta
      itemProp={prop}
      content={content}
    />
  )
}

export default SchemaMeta
